import { DataModel } from 'common/models/utility-models/base-model';
import { GridModel } from 'common/models/utility-models/list-utility.model';

export class UploadStudentDocModel extends DataModel {}

export class UploadStudentDocGridModel extends UploadStudentDocModel {}

export class UploadStudentDocListingModel extends GridModel<UploadStudentDocGridModel> {}

export class UploadStudentDocPageModel {
  assessmentExcelFile: File | any = '';
  assessmentExcelFileError: string = '';
  keyDetails: UploadStudentDocDetails[] = [];
  allApplications: any = [];
  assessmentExcelFileData: any = [];
  arrayBuffer: any;
  jsonData:any=[];
  isExcelFileUploaded:boolean = false;
  constructor() {
    this.keyDetails.push(assessment);
    this.keyDetails.push(feedback);
    this.keyDetails.push(homevisit);

  }
}

export class UploadStudentDocDetails {
  title: string = '';
  header: string[] = [];
  key: string[] = [];
  value: any[] = [{}];
}

const assessment: UploadStudentDocDetails = new UploadStudentDocDetails();
assessment.title = 'Assessment';
assessment.header = [
  'Full Name',
  'Marks Gained',
  'Max Marks',
  'Assessment Type',
  'Email ID',
];


const feedback: UploadStudentDocDetails = new UploadStudentDocDetails();
feedback.title = 'Interview';

feedback.header = [
  'Full Name',
  'Status',
  'Feedback',
  'Email ID',
];



const homevisit: UploadStudentDocDetails = new UploadStudentDocDetails();
homevisit.title = 'Home Visit';

homevisit.header = [
  'Full Name',
  'Occupation',
  'Parents Education',
  'Housing/Assets',
  'Social Skills',
  'Email ID',
  'Remarks',
  'Total'
];

export class PostModel

  {
    interviewStatus:string= "";
    interviewFeedback:string= "";
    email:string= ""
}



